/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Roots_EmptyInputs */

const cs_documents_roots_empty = /** @type {(inputs: Documents_Roots_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné kořenové složky. Vytvořte první.`)
};

const en_documents_roots_empty = /** @type {(inputs: Documents_Roots_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No root folders yet. Create one to get started.`)
};

/**
* | output |
* | --- |
* | "No root folders yet. Create one to get started." |
*
* @param {Documents_Roots_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_roots_empty = /** @type {((inputs?: Documents_Roots_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Roots_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_roots_empty(inputs)
	return cs_documents_roots_empty(inputs)
});